import axios from 'axios';

import { config } from '../config';
import type { DashboardRole } from '../types/auth';

export interface LoginSuccessPayload {
  status: 'ok';
  token: string;
  issuedAt: string;
  expiresAt: string;
  user: {
    userId: string;
    email: string | null;
    name: string | null;
    roles: DashboardRole[];
  };
}

export class DashboardLoginError extends Error {
  readonly status: string;
  readonly retryAt?: string;

  constructor(message: string, status: string, retryAt?: string) {
    super(message);
    this.name = 'DashboardLoginError';
    this.status = status;
    this.retryAt = retryAt;
  }
}

const authClient = axios.create({
  baseURL: config.apiAuthBaseUrl,
  timeout: 15_000
});

export const loginWithCredentials = async (
  email: string,
  password: string
): Promise<LoginSuccessPayload> => {
  try {
    const response = await authClient.post<LoginSuccessPayload>('/login', {
      email,
      password
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const data = error.response.data as { status?: string; message?: string; retryAt?: string } | undefined;
      const status = data?.status ?? 'error';
      const message = data?.message ?? '登录失败，请稍后再试';
      throw new DashboardLoginError(message, status, data?.retryAt);
    }

    throw new DashboardLoginError('网络异常，请检查连接后重试', 'network');
  }
};

export const logoutSession = async () => {
  try {
    await authClient.post('/logout');
  } catch (_error) {
    // ignore logout errors; session will be considered cleared locally
  }
};
